import React, { useState } from 'react';
import { Box, Typography, Grid, Card, CardContent, TextField, Button, Stack, Chip } from '@mui/material';
import usePortfolioStore from '../../store/portfolioStore.js';
import useAuthStore from '../../store/authStore.js';

export default function Admin() {
  const addProject = usePortfolioStore((s) => s.addProject);
  const addTestimonial = usePortfolioStore((s) => s.addTestimonial);
  const updateAbout = usePortfolioStore((s) => s.updateAbout);
  const updateContacts = usePortfolioStore((s) => s.updateContacts);
  const addLiveSite = usePortfolioStore((s) => s.addLiveSite);
  const removeLiveSite = usePortfolioStore((s) => s.removeLiveSite);
  const addSkillCategory = usePortfolioStore((s) => s.addSkillCategory);
  const removeSkillCategory = usePortfolioStore((s) => s.removeSkillCategory);
  const exportJSON = usePortfolioStore((s) => s.exportJSON);
  const importJSON = usePortfolioStore((s) => s.importJSON);
  const state = usePortfolioStore((s) => s);
  const repos = usePortfolioStore((s) => s.repos);
  const pinProject = usePortfolioStore((s) => s.pinProject);
  const unpinProject = usePortfolioStore((s) => s.unpinProject);
  const logout = useAuthStore((s) => s.logout);

  const [proj, setProj] = useState({ name: '', description: '', url: '', homepage: '' });
  const [test, setTest] = useState({ author: '', role: '', text: '' });
  const [aboutForm, setAboutForm] = useState(state.about);
  const [contactsForm, setContactsForm] = useState(state.contacts);
  const [siteUrl, setSiteUrl] = useState('');
  const [newCat, setNewCat] = useState('');
  const [newItems, setNewItems] = useState('');
  const [jsonText, setJsonText] = useState('');

  return (
    <Box>
      <Box display="flex" justifyContent="space-between" alignItems="center" sx={{ mb: 2 }}>
        <Typography variant="h5">Admin Panel</Typography>
        <Button onClick={logout}>Logout</Button>
      </Box>

      <Grid container spacing={2}>
        <Grid item xs={12} md={6}>
          <Card className="glass">
            <CardContent>
              <Typography variant="h6" gutterBottom>About</Typography>
              <TextField label="Headline" fullWidth sx={{ mb: 1 }} value={aboutForm.headline} onChange={(e)=>setAboutForm({...aboutForm, headline:e.target.value})} />
              <TextField label="Summary" fullWidth multiline minRows={3} sx={{ mb: 2 }} value={aboutForm.summary} onChange={(e)=>setAboutForm({...aboutForm, summary:e.target.value})} />
              <Button variant="contained" onClick={()=>updateAbout(aboutForm)}>Save About</Button>
            </CardContent>
          </Card>
        </Grid>

        <Grid item xs={12} md={6}>
          <Card className="glass">
            <CardContent>
              <Typography variant="h6" gutterBottom>Contacts</Typography>
              <TextField label="WhatsApp" fullWidth sx={{ mb: 1 }} value={contactsForm.whatsapp} onChange={(e)=>setContactsForm({...contactsForm, whatsapp:e.target.value})} />
              <TextField label="Email" type="email" fullWidth sx={{ mb: 2 }} value={contactsForm.email} onChange={(e)=>setContactsForm({...contactsForm, email:e.target.value})} />
              <Button variant="contained" onClick={()=>updateContacts(contactsForm)}>Save Contacts</Button>
            </CardContent>
          </Card>
        </Grid>

        <Grid item xs={12} md={6}>
          <Card className="glass">
            <CardContent>
              <Typography variant="h6" gutterBottom>Live Sites</Typography>
              <Stack direction={{ xs: 'column', sm: 'row' }} spacing={1} sx={{ mb: 2 }}>
                <TextField label="Add URL" fullWidth value={siteUrl} onChange={(e)=>setSiteUrl(e.target.value)} />
                <Button variant="contained" onClick={()=>{ if(siteUrl){ addLiveSite(siteUrl); setSiteUrl(''); } }}>Add</Button>
              </Stack>
              <Stack direction="row" useFlexGap flexWrap="wrap" spacing={1}>
                {state.liveSites.map(u => (
                  <Chip key={u} label={u} onDelete={()=>removeLiveSite(u)} />
                ))}
              </Stack>
            </CardContent>
          </Card>
        </Grid>

        <Grid item xs={12} md={6}>
          <Card className="glass">
            <CardContent>
              <Typography variant="h6" gutterBottom>Skills</Typography>
              <TextField label="Category" fullWidth sx={{ mb: 1 }} value={newCat} onChange={(e)=>setNewCat(e.target.value)} />
              <TextField label="Items (comma separated)" fullWidth sx={{ mb: 2 }} value={newItems} onChange={(e)=>setNewItems(e.target.value)} />
              <Stack direction="row" spacing={1} sx={{ mb: 2 }}>
                <Button variant="contained" onClick={()=>{ if(newCat){ addSkillCategory(newCat, newItems.split(',').map(s=>s.trim()).filter(Boolean)); setNewCat(''); setNewItems(''); } }}>Add Category</Button>
              </Stack>
              <Stack direction="row" useFlexGap flexWrap="wrap" spacing={1}>
                {state.skillsCatalog.map(c => (
                  <Chip key={c.category} label={c.category} onDelete={()=>removeSkillCategory(c.category)} />
                ))}
              </Stack>
            </CardContent>
          </Card>
        </Grid>

        <Grid item xs={12} md={6}>
          <Card className="glass">
            <CardContent>
              <Typography variant="h6" gutterBottom>Add Project</Typography>
              <TextField label="Name" fullWidth sx={{ mb: 1 }} value={proj.name} onChange={(e)=>setProj({...proj, name:e.target.value})} />
              <TextField label="Description" fullWidth sx={{ mb: 1 }} value={proj.description} onChange={(e)=>setProj({...proj, description:e.target.value})} />
              <TextField label="Repository URL" fullWidth sx={{ mb: 1 }} value={proj.url} onChange={(e)=>setProj({...proj, url:e.target.value})} />
              <TextField label="Live URL (optional)" fullWidth sx={{ mb: 2 }} value={proj.homepage} onChange={(e)=>setProj({...proj, homepage:e.target.value})} />
              <Button variant="contained" onClick={()=>{ if(proj.name && proj.url){ addProject(proj); setProj({ name:'', description:'', url:'', homepage:''}); } }}>Add</Button>
            </CardContent>
          </Card>
        </Grid>

        <Grid item xs={12}>
          <Card className="glass">
            <CardContent>
              <Typography variant="h6" gutterBottom>Manage Pinned Projects</Typography>
              <Typography variant="body2" sx={{ mb: 1, opacity: .8 }}>Pin or unpin any repository to feature it on the Home page.</Typography>
              <Grid container spacing={1}>
                {repos.map((r) => {
                  const isPinned = state.pinnedProjectIds.includes(r.id);
                  return (
                    <Grid item xs={12} md={6} key={r.id}>
                      <Stack direction={{ xs: 'column', sm: 'row' }} spacing={1} alignItems="center" justifyContent="space-between">
                        <Typography variant="subtitle2">{r.name}</Typography>
                        <Stack direction="row" spacing={1}>
                          {isPinned ? (
                            <Button size="small" color="secondary" onClick={()=>unpinProject(r.id)}>Unpin</Button>
                          ) : (
                            <Button size="small" onClick={()=>pinProject(r.id)}>Pin</Button>
                          )}
                        </Stack>
                      </Stack>
                    </Grid>
                  );
                })}
              </Grid>
            </CardContent>
          </Card>
        </Grid>

        <Grid item xs={12} md={6}>
          <Card className="glass">
            <CardContent>
              <Typography variant="h6" gutterBottom>Add Testimonial</Typography>
              <TextField label="Author" fullWidth sx={{ mb: 1 }} value={test.author} onChange={(e)=>setTest({...test, author:e.target.value})} />
              <TextField label="Role" fullWidth sx={{ mb: 1 }} value={test.role} onChange={(e)=>setTest({...test, role:e.target.value})} />
              <TextField label="Text" fullWidth multiline minRows={3} sx={{ mb: 2 }} value={test.text} onChange={(e)=>setTest({...test, text:e.target.value})} />
              <Button variant="contained" onClick={()=>{ if(test.author && test.text){ addTestimonial(test); setTest({ author:'', role:'', text:''}); } }}>Add</Button>
            </CardContent>
          </Card>
        </Grid>

        <Grid item xs={12}>
          <Card className="glass">
            <CardContent>
              <Typography variant="h6" gutterBottom>Import / Export</Typography>
              <Stack direction={{ xs: 'column', sm: 'row' }} spacing={1} sx={{ mb: 1 }}>
                <Button onClick={()=>{
                  const data = exportJSON();
                  const blob = new Blob([data], { type: 'application/json' });
                  const url = URL.createObjectURL(blob);
                  const a = document.createElement('a');
                  a.href = url; a.download = 'portfolio-data.json'; a.click();
                  URL.revokeObjectURL(url);
                }}>Export JSON</Button>
                <Button variant="outlined" onClick={()=>{
                  const ok = importJSON(jsonText);
                  if (ok) setJsonText('');
                }}>Import JSON</Button>
              </Stack>
              <TextField placeholder="Paste JSON here to import" fullWidth multiline minRows={4} value={jsonText} onChange={(e)=>setJsonText(e.target.value)} />
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </Box>
  );
}


